<template>
	<div class="main">
		<div class="naverwebtoon">
			<img class="close b-close" src="../assets/image/close.png" alt="">
			<a href=""><img src="../assets/image/naverwebtoon_bigbanner.png" alt=""></a>
		</div>
		<div class="box">
			<Header></Header>
			<GameBanner :src="game.topBgImage" :variant="game.extraFields.bannerType"
				:drawProductId="game.extraFields.bannerDrawProductId" />
			<div class="item_welfare">
				<div class="content">
					<UserInfo ref="userInfo"></UserInfo>
					<div class="describe">
						<img src="../assets/image/push.png" alt="">
						<span>|</span>
						<p class="marquee"><span>{{ $t('orders_tips_text') }}</span></p>
					</div>
					<div class="position">
						<div :class="orderList.length == 0 ? 'items-grid-no-data' : 'items-grid'">
							<div v-for="(item, index) in orderList" :key="index" class="item-card">
								<div class="order-item">
									<div class="order-header">
										<img :src="game.gameIcon" class="game-icon">
										<span class="order-id">{{ $t('order_id_text') }}: {{ item.orderId }}</span>
										<button @click="copyOrderId(item.orderId)" class="copy-btn">
											<svg class="copy-icon" viewBox="0 0 24 24">
												<path
													d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z" />
											</svg>
											{{ $t('copy_text') }}
										</button>
									</div>
									<div class="order-details">
										<div class="detail-row">
											<span>{{ $t('payment_type_text') }}:
												{{ capitalizeFirstLetter(item.cashflow) }}</span>
											<span>{{ $t('amount_text') }}: {{ item.currency || '' }}
												{{ item.amount || '' }}</span>
										</div>
										<div class="detail-row">
											<span>{{ $t('game_server_text') }}: {{ item.serverName }}</span>
											<span>{{ $t('game_role_text') }}: {{ item.roleName }}</span>
										</div>
										<div class="detail-row">
											<span>{{ $t('payment_time_text') }}: {{ item.time }}</span>
										</div>
									</div>
								</div>
							</div>
							<div v-if="orderList.length == 0">
								<div class="no-data">
									<svg width="184" height="152" viewBox="0 0 184 152"
										xmlns="http://www.w3.org/2000/svg">
										<g fill="none" fillRule="evenodd">
											<g transform="translate(24 31.67)">
												<ellipse fillOpacity=".8" fill="#F5F5F7" cx="67.797" cy="106.89"
													rx="67.797" ry="12.668"></ellipse>
												<path
													d="M122.034 69.674L98.109 40.229c-1.148-1.386-2.826-2.225-4.593-2.225h-51.44c-1.766 0-3.444.839-4.592 2.225L13.56 69.674v15.383h108.475V69.674z"
													fill="#AEB8C2"></path>
												<path
													d="M101.537 86.214L80.63 61.102c-1.001-1.207-2.507-1.867-4.048-1.867H31.724c-1.54 0-3.047.66-4.048 1.867L6.769 86.214v13.792h94.768V86.214z"
													fill="url(#linearGradient-1)" transform="translate(13.56)"></path>
												<path
													d="M33.83 0h67.933a4 4 0 0 1 4 4v93.344a4 4 0 0 1-4 4H33.83a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4z"
													fill="#F5F5F7"></path>
												<path
													d="M42.678 9.953h50.237a2 2 0 0 1 2 2V36.91a2 2 0 0 1-2 2H42.678a2 2 0 0 1-2-2V11.953a2 2 0 0 1 2-2zM42.94 49.767h49.713a2.262 2.262 0 1 1 0 4.524H42.94a2.262 2.262 0 0 1 0-4.524zM42.94 61.53h49.713a2.262 2.262 0 1 1 0 4.525H42.94a2.262 2.262 0 0 1 0-4.525zM121.813 105.032c-.775 3.071-3.497 5.36-6.735 5.36H20.515c-3.238 0-5.96-2.29-6.734-5.36a7.309 7.309 0 0 1-.222-1.79V69.675h26.318c2.907 0 5.25 2.448 5.25 5.42v.04c0 2.971 2.37 5.37 5.277 5.37h34.785c2.907 0 5.277-2.421 5.277-5.393V75.1c0-2.972 2.343-5.426 5.25-5.426h26.318v33.569c0 .617-.077 1.216-.221 1.789z"
													fill="#DCE0E6"></path>
											</g>
											<path
												d="M149.121 33.292l-6.83 2.65a1 1 0 0 1-1.317-1.23l1.937-6.207c-2.589-2.944-4.109-6.534-4.109-10.408C138.802 8.102 148.92 0 161.402 0 173.881 0 184 8.102 184 18.097c0 9.995-10.118 18.097-22.599 18.097-4.528 0-8.744-1.066-12.28-2.902z"
												fill="#DCE0E6"></path>
											<g transform="translate(149.65 15.383)" fill="#FFF">
												<ellipse cx="20.654" cy="3.167" rx="2.849" ry="2.815"></ellipse>
												<path d="M5.698 5.63H0L2.898.704zM9.259.704h4.985V5.63H9.259z"></path>
											</g>
										</g>
									</svg>
									<p class="no-data-text">{{ $t('no_data_text') }}</p>
								</div>
							</div>
						</div>
						<div v-if="orderList.length > 0" class="pagination">
							<button @click="prevPage" :disabled="currentPage === 1" class="page-btn">
								{{ $t('pagination.previous') }}
							</button>
							<span class="page-info">{{ $t('pagination.page_info', {
								current: currentPage, total:
									totalPages }) }}</span>
							<button @click="nextPage" :disabled="currentPage === totalPages" class="page-btn">
								{{ $t('pagination.next') }}
							</button>
						</div>
					</div>
				</div>
			</div>
			<Footer></Footer>
		</div>
	</div>
</template>

<script>
import Header from '../components/header.vue'
import Footer from '../components/footer.vue'
import UserInfo from '../components/userInfo.vue'
import TipsWindow from '../components/tipsWindow.vue'
import GameBanner from '../components/GameBanner.vue'
import axios from 'axios'
import {
	isEmpty,
	isNotEmpty
} from '../utils/index.js'

export default {
	name: 'dailySignIn',
	components: {
		Header,
		Footer,
		UserInfo,
		GameBanner,
		TipsWindow
	},
	data() {
		return {
			orderList: [],
			game: this.$store.state.gameData,
			total: 0,
			pageSize: 6,
			currentPage: 1
		}
	},
	computed: {
		totalPages() {
			return Math.ceil(this.total / this.pageSize);
		}
	},
	mounted() {
		this.loadOrderList();
	},
	methods: {
		prevPage() {
			if (this.currentPage > 1) {
				this.currentPage--;
				this.loadOrderList();
			}
		},
		nextPage() {
			if (this.currentPage < this.totalPages) {
				this.currentPage++;
				this.loadOrderList();
			}
		},
		loadOrderList: function () {
			if (this.$session.hasLogin()) {
				this.$axios({
					method: 'get',
					url: '/web/api/payment/orderRecords',
					params: {
						userId: this.$session.getUserId(),
						gameCode: this.$cache.getGameCode(),
						pageNo: this.currentPage,
						pageSize: this.pageSize
					}
				})
					.then(response => {
						if (response.code === 1000) {
							this.total = response.data.totalNum;
							this.orderList = response.data.orderList;
						}
					})
			}
		},
		handlePageChange(page) {
			this.currentPage = page;
			this.loadOrderList();
		},
		capitalizeFirstLetter(str) {
			if (!str) return '';
			return str.charAt(0).toUpperCase() + str.slice(1);
		},
		copyOrderId(orderId) {
			navigator.clipboard.writeText(orderId)
				.then(() => {
					this.$toast.success(this.$t('copy_successful_text'));
				})
				.catch(() => {
					this.$toast.error(this.$t('copy_fail_text'));
				});
		}
	}
}
</script>
// ... existing code ...
<style scoped>
.order-item {
	border: 1px solid #f0f0f0;
	border-radius: 12px;
	padding: 16px;
	margin-bottom: 16px;
	background: white;
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.order-header {
	display: flex;
	align-items: center;
	margin-bottom: 12px;
	padding-bottom: 8px;
	border-bottom: 1px solid #f5f5f5;
}

.game-icon {
	width: 36px;
	height: 36px;
	margin-right: 12px;
	border-radius: 4px;
}

.order-id {
	font-weight: 600;
	font-size: 15px;
	color: #333;
}

.detail-row {
	display: flex;
	justify-content: space-between;
	margin-bottom: 8px;
	font-size: 14px;
}

.detail-row span {
	flex: 1;
	color: #666;
}

.detail-row span:first-child {
	font-weight: 500;
	color: #444;
}

.items-grid {
	padding: 8px;
	background: #f9f9f9;
	border-radius: 12px;
}

.items-grid-no-data {
	padding: 8px;
	border-radius: 12px;
}

.pagination {
	display: flex;
	justify-content: center;
	align-items: center;
	gap: 20px;
	margin-top: 20px;
}

.page-btn {
	padding: 8px 16px;
	background-color: var(--theme-color, --theme-color);
	color: white;
	border: none;
	border-radius: 4px;
	cursor: pointer;
}

.page-btn:disabled {
	background-color: #ccc;
	cursor: not-allowed;
}

.page-info {
	font-size: 14px;
	color: #666;
}

.copy-btn {
	margin-left: 10px;
	padding: 0;
	background: none;
	border: none;
	color: var(--theme-color, --theme-color);
	font-size: 12px;
	cursor: pointer;
	display: flex;
	align-items: center;
}

.copy-icon {
	width: 14px;
	height: 14px;
	margin-right: 4px;
	fill: currentColor;
}

.copy-btn:hover {
	opacity: 0.8;
}

@media (max-width: 768px) {
	.order-item {
		padding: 12px;
	}

	.detail-row {
		flex-direction: column;
		gap: 4px;
	}

	.detail-row span {
		width: 100%;
	}

	.game-icon {
		width: 28px;
		height: 28px;
		margin-right: 8px;
	}
}

/* 移动端适配 */
@media (max-width: 768px) {
	.copy-btn {
		font-size: 10px;
		margin-left: 6px;
	}

	.copy-btn::before {
		width: 12px;
		height: 12px;
		margin-right: 2px;
	}

	.order-id {
		font-size: 13px;
	}
}

.no-data {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	height: 100%;
	padding: 20px;
}

.no-data-text {
	margin-top: 16px;
	color: #999;
	font-size: 14px;
	text-align: center;
}
</style>